import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../config/Config';

const PaytmPost = ({ checkSum, paymentData, txnToken, sub_action_url }) => {
	useEffect(() => {
		if (checkSum !== '') {
			const script = document.createElement('script');
			var code = 'document.paymentform.submit();';
			script.async = true;
			script.appendChild(document.createTextNode(code));
			document.body.appendChild(script);
		}
	}, [checkSum]);

	var paramsList = '';
	if (typeof paymentData !== 'undefined') {
		if (localStorage.getItem('payment_type')?.toLowerCase() === 'stripe') {
			paramsList = (
				<input type="hidden" name="ORDER_ID" value={paymentData['ORDER_ID']} />
			);
		} else {
			paramsList = Object.keys(paymentData).map(function (param_key) {
				return (
					<input type="hidden" name={param_key} value={paymentData[param_key]} />
				);
			});
		}
	}
	let formAction = Config.PAYTMURL
	if (localStorage.getItem('payment_type')?.toLowerCase() === 'stripe') {
		formAction = paymentData['postUrl']
	} else if(sub_action_url != '') {
		formAction = sub_action_url
	}
	return (
		<div>
			{
				<form
					method="post"
					action={formAction}
					name="paymentform"
				>
					
					{txnToken != '' ? (
						<div>
						<input type="hidden" name="txnToken" value={txnToken} />
						<input type="hidden" name="ORDER_ID" value={paymentData['ORDER_ID']} />
						<input type="hidden" name="mid" value="Kastur90883456339710" />
						</div>
					) : (
						<div>
							{paramsList}
							<input type="hidden" name="CHECKSUMHASH" value={checkSum} />
						</div>
					)}
					
				</form>
			}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { checkSum, paymentData, txnToken, sub_action_url} = state.rootReducer.buyCourse;
	return {
		checkSum,
		paymentData,
		txnToken,
		sub_action_url,
	};
};

export default connect(mapStateToProps)(PaytmPost);
